export const limitNotificationBadgeCount = (
  count: string | number,
  max: string | number
) => (count > max ? `${max}+` : `${count}`);
